import { Link } from 'react-router-dom';
import ArticleLayout from '@/pages/article/components/ArticleLayout';
import Footer from '@/pages/home/components/Footer';

export default function BasetaoShippingCost() {
  return (
    <>
      <ArticleLayout title="Basetao Shipping Cost 2026: Complete Price Guide & Cheapest Options" subtitle="Detailed breakdown of every Basetao shipping method, real cost estimates by weight and destination, and proven strategies to minimize international delivery expenses." tag="Shipping">
        <section className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">Understanding Basetao Shipping Costs</h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            Shipping is the most significant variable cost when using <strong className="text-foreground-900">Basetao</strong>. Prices depend on package weight, dimensions, destination country, and chosen carrier. EUB remains the cheapest for sub-2kg parcels (roughly $5-15/kg), while EMS balances speed and cost at $12-25/kg. DHL and FedEx express services run $20-40/kg but deliver within a week.
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            The most effective cost-saving tactic is warehouse consolidation &mdash; storing multiple items and shipping them together. Visit the <Link to="/" className="text-primary-600 hover:text-primary-700 font-medium underline">Basetao Spreadsheet homepage</Link> for tools that help you plan and budget your shipments effectively.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">Cost Comparison by Destination</h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-center">
            {[
              { region: 'USA', budget: 'EUB: $8-15/kg', express: 'DHL: $22-35/kg' },
              { region: 'Europe', budget: 'EUB: $7-14/kg', express: 'DHL: $20-32/kg' },
              { region: 'UK', budget: 'EUB: $8-16/kg', express: 'DHL: $21-34/kg' },
            ].map((r) => (
              <div key={r.region} className="p-4 rounded-lg bg-background-100 border border-background-200/70">
                <h4 className="text-sm font-semibold text-foreground-900 mb-2">{r.region}</h4>
                <p className="text-xs text-foreground-600">{r.budget}</p>
                <p className="text-xs text-foreground-600">{r.express}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-8">
          <div className="bg-primary-50/50 border border-primary-200/50 rounded-lg p-6 md:p-8 text-center">
            <h2 className="font-heading text-xl font-bold text-foreground-900 mb-3">Need More Help?</h2>
            <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              <div className="w-4 h-4 flex items-center justify-center"><i className="ri-home-line text-sm"></i></div>
              Back to BasetaoSheet Home
            </Link>
          </div>
        </section>
      </ArticleLayout>
      <Footer />
    </>
  );
}